import { render, staticRenderFns } from "./CreateLayetteFormed.vue?vue&type=template&id=f37a6d80"
import script from "./CreateLayetteFormed.vue?vue&type=script&lang=js"
export * from "./CreateLayetteFormed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports